export const BRIDGE_NO_TOP_INSET_REGEXP = [];

export const BRIDGE_NO_TOP_INSET_KEY = 'top-safearea';
